<template>
    <v-container fluid>
        <app-header  v-if="headerState" :hideTitle="!titleState">
            <span slot="title">{{$route.name=='JBControl'?qname?'Touch - '+qname:'Touch':'Touch'}}</span>
        </app-header>
        <v-row>
          <keep-alive>
            <router-view :mms="mms" :mmsReady="mmsReady" :jboardSettings="settings"></router-view>
          </keep-alive>
            <v-bottom-navigation fixed grow>
              <v-btn width="25%" tile :to="{name:'Shortcut'}">Shortcut</v-btn>
              <v-btn width="25%" tile :to="{name:'JBControl',query:{qname:qname,ddn:ddn}}">Remote</v-btn>
              <v-btn width="25%" tile :to="{name:'JBSettings',query:{qname:qname,ddn:ddn}}">Settings</v-btn>
             </v-bottom-navigation>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import conf from "@/config/config";
import {
  set as setCookie,
  get as getCookie
} from "es-cookie";
import webmms from "webmms-client";
export default {
    name:"Touch",
    props: ['pageParams'],
    data(){
        return {
            qname:this.$route.query.qname,
            ddn:this.$route.query.ddn,
            settings:[
                {'cmd':'fullscreen','option':'showFullscreen','value':false,'text':'Fullscreen'},
                {'cmd':'autoplay','option':'setAutoplay','value':false,'text':'Autoplay'},
                {'cmd':'loop','option':'setLoop','value':false,'text':'Loop'},
                {'cmd':'darkmode','option':'setDarkMode','value':false,'text':'Dark Mode'},
                {'cmd':'qrcode','option':'setQRCode','value':false,'text':'QR Code'},
                {'cmd':'shortcut','option':'setShortcut','value':false,'text':'Shortcut'},
            ],
            json:{},
            errorMsg: "",
            errorLoading: false,
            params: null,
            error: true,
            errorLoading: false,
            msg: "",
            err:"",
            mmsReady: false,
            mms: null,
            eiInfo: {
              eiName: "",
              eiTag: "",
              ddn: ""
            },
            EiToken:null,
            SToken:null,
            webmmsOptions:{
              EiToken:"",
              SToken:"",
              UToken:""
            },
            topic:"",
            payload:null,
            func:null
        }
    },
    computed:{
      ...mapGetters([
        'headerState',
        'footerState',
        'titleState'
      ])
    },
    mixins:[],
    watch:{
        mmsReady:{
          async handler(val){
            if(val){
              let reply=await this.mms.sendMMS({
                                topic: '',
                                DDN:`ddn/${this.ddn}`,
                                payload: {'qname':this.qname,'cmd':'getSettings'}
                    });
              console.log(reply);
              this.settings.forEach(e=>e['value']=reply[0].Reply.payload[e.option]);

            }
        },
            immediate:true
        },
    },
    created(){
      const {qname, ddn} = this.pageParams;
      this.qname = qname;
      this.ddn = ddn;
    },
    methods:{
        checkWebMMSState(){
            if(!this.mmsReady)
            {
              this.errorMsg = "WebMMS is not connected or registered.";
              this.errorLoading = true;
              return false;
            }else return  true;

        },
        async loadList(){

          let payload = {
              noCache: true,
              allData: true
          }

          payload.condition = {type: 'dock'}
          if(this.qname)
            payload.condition.qname = this.qname.toLowerCase();
            //payload.condition.qname =  { $regex: this.qname, $options: 'i' };
          if(this.qcode)
            payload.condition.qcode = this.qcode;
          if(this.qdigit)
            payload.condition.qdigit = this.qdigit;

          if(!this.checkWebMMSState())
            return;

          try {
            console.log(payload);
          let res = await this.mms.callMMS({
              topic: '',
              DDN: conf.objstore,
              func: "obj://list",
              payload: payload
          });


          if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];

                if(!result)
                  return;
                console.log(result);

                if(result[0]){
                  result = result[0];
                }

                if(result.Reply != ''){
                  if(result.Reply.ErrMsg == 'OK'){
                    let data = result.Reply.Data.Data[0];
                    if(data){
                      this.json = data.data.dock ? data.data.dock : data.data;
                      if(!this.json.layout)
                      this.json = {
                        layout : this.json
                      }
                      this.json.boardList = [];
                      this.json.layout.forEach((item, index) => {
                        if(item.board){
                            let board = item.board.data ? item.board.data : item.board;
                            this.json.boardList.push(board);
                        }

                      });
                      console.log(this.json);
                      if(this.preJboardList.findIndex(p=> p.qname == this.qname) < 0)
                        this.preJboardList.push({qname: this.qname, qcode: this.qcode, qdigit: this.qdigit});
                      // if(this.json && this.json.length){
                      //   this.currentBoard = this.json[0] || {};
                      //   if(this.currentBoard.board && this.currentBoard.board.data)
                      //      this.currentBoard = this.currentBoard.board.data;
                      // }

                    }else{
                      this.errorMsg = 'jboard not found';
                      this.errorLoading = true;
                    }
                  }else{
                    this.errorMsg = result.Reply.ErrMsg;
                    this.errorLoading = true;
                  }
                }else{
                  this.result = [];
                  this.totalItems = 0;
                  if (result.IN.State){
                    this.errorMsg = result.IN.State.ErrMsg;
                    this.errorLoading = true;
                  }
                }
            }
          } catch (error) {
              this.errorMsg = error;
              this.errorLoading = true;
          }
      },
      async subscribeMMS() {
            this.removeEvent = this.mms.on("registered", async reply => {
            if(process.env.NODE_ENV!= 'production')
              console.log('reply=%s', JSON.stringify(reply))
            if (reply.ErrMsg == "OK") {
              this.eiInfo.ddn = reply.result.DDN;
              this.webmmsOptions.EiToken = reply.result.EiToken;
              this.webmmsOptions.SToken = reply.result.SToken;
              this.webmmsOptions.UToken = reply.result.UToken;
              if (this.eiInfo.eiName == "") {
                this.eiInfo.eiName = reply.result.EiName
                  ? reply.result.EiName
                  : "pgTOUCH" + this.makeId(5);
              }
              if (this.eiInfo.eiTag == "") {
                this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : "";
              }
              this.mmsReady = true;
              this.error = false;
            } else {
              this.mmsReady = false;
              this.error = false;
            }

            setCookie("EiToken", this.webmmsOptions.EiToken);
            setCookie("SToken", this.webmmsOptions.SToken);

            console.log("regtoCenter: %s", reply.ErrMsg);

            let deviceInfo = {
              DDN: this.eiInfo.ddn,
              EiOwner: "",
              EiName: this.eiInfo.eiName,
              EiType: ".page",
              EiTag: this.eiInfo.eiTag,
              EiLoc: ""
            };
            let result = await this.mms.setDeviceInfo(deviceInfo);

            console.log(`SetDevice reply=${JSON.stringify(result)}`);
            await this.track(this.mms, 'touch', this.pageParams);

        });

        this.mms.on("message", (method, from, data, cb) => {
          this.mmsReady = true;
          this.error = false;
          console.log('rcve: ',from, data);
          //body();
          if (typeof data == "object" && !data.from) data.from = from;
          //body.sender = data;
          if (data) {
            if(data.qname==this.qname){
              if(data.cmd)
                switch(data.cmd){
                  case 'getSettings':
                    this.settings.forEach(e=>e['value']=data.payload[e.option]);
                    cb({'ErrCode':0,'ErrMsg':'OK'});
                    break;
                }
            }
          }
        });

        this.mms.on("state", msg => {
          console.log("WS error: %s", msg);
          this.mmsReady = false;
          this.error = true;
          this.loading = false;
        });

        this.mms.on("disconnect", msg => {
          console.log(msg);
          this.mmsReady = false;
          this.error = true;
          this.loading = false;
        });

        this.mms.on("error", err => {
          console.log(err);
          this.mmsReady = false;
          this.error = true;
          this.loading = false;
        });

        this.mms.on("connect_error", err => {
          console.log(err);
          this.mmsReady = false;
          this.error = true;
          this.loading = false;
        });

        this.mms.on("connect_timeout", err => {
          console.log(err);
          this.mmsReady = false;
          this.error = true;
          this.loading = false;
        });
      }
    },
    async created(){
      this.EiToken=getCookie('EiToken')||'';
      this.SToken=getCookie('SToken')||'';
      this.mms=webmms({wsurl:conf.wsurl,EiToken:this.EiToken,SToken:this.SToken});
    },
    async beforeMount() {
      await this.subscribeMMS();
    },
    beforeDestroy() {
      this.removeEvent();
    }
}
</script>
